<template>
  <Page subtype="whywithus" class="m-5 sm:m-7" :show-header="false" />
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import Page from "@components/content/page";

defineI18nRoute({
  paths: {
    cs: '/proc-inzerovat-u-nas',
    en: '/why-advertise-with-us',
    sk: '/preco-inzerovat-u-nas',
    pl: '/dlaczego-warto-sie-u-nas-reklamowac',
    de: '/warum-bei-uns-werben'
  }
});

const config = useRuntimeConfig();
const canonical = config.public.appBaseUrl + translatePath(ROUTES.CODE.WHY_WITH_US);

useHead({ link: [ { rel: 'canonical', href: canonical } ] });

</script>
